import styled from 'styled-components';
import { DataTable } from '@/components/TimeSeries';
import { media } from '@simplywallst/ui-core';

export const TooltipTable = styled(DataTable)`
  // Prevent the table from overflowing when its content is larger than its container
  table-layout: fixed;
  width: 100%;
  padding: ${({ theme }) => theme.x0_5}px ${({ theme }) => theme.x1}px;
  tbody tr td {
    padding: ${({ theme }) => theme.x0_25}px;
    &:last-child {
      text-align: right;
    }
    &:nth-child(1) {
      width: 100px;
    }
    &:nth-child(2) {
      width: 70px;
      padding-left: 0;
    }
    &:nth-child(3) {
      width: auto;
    }
    &:nth-child(4) {
      width: 70px;
    }

    ${media.smUp`
      &:nth-child(1) {
        width: 122px;
      }
      
    `};

    word-wrap: break-word;
    white-space: break-spaces;
  }
  tr:last-child {
    td {
      border-bottom: none;
    }
  }
`;
